import axios from 'axios'

const request = axios.create({
    // baseURL: 'http://114.88.161.211:8033',
    // baseURL: 'https://test.dayulong.cn/napi',
    baseURL: process.env.VUE_APP_BASE_API,
    changeOrigin: true
})

request.interceptors.request.use(function(config){
    config.headers['terminal'] = 2
    if(window.localStorage.getItem('appUserToken')){
        // console.log('Bearer ' + window.localStorage.getItem('appUserToken'))
        config.headers["authorization"] = 'Bearer ' + window.localStorage.getItem('appUserToken')
    }
    return config
},function(error){
    return Promise.reject(error)
})

request.interceptors.response.use(function(response){
    // alert(JSON.stringify(response))
    const res = response.data
    return res
}, function (error){
    return Promise.reject(error)
})

export default request